import {
    archiveJob,
    createJob,
    deleteJob,
    editJob,
    getJob,
    listJobs,
    listTags,
    unarchiveJob,
    updateExternalReferences,
} from './client';
import { CreateJobPayload, GetJobsParams, UpdateExternalReferencesPayload } from './job';
import { EditJobPayload } from './types';
import { listInvoicesByJobId } from 'store/invoices/client';

export const doCreateJob: Function = (payload: CreateJobPayload) => async (dispatch: Function) => {
    dispatch({ type: 'CREATE_JOB_REQUEST' });
    try {
        const createdJob = await createJob(payload);

        dispatch({
            type: 'CREATE_JOB_SUCCESS',
            payload: createdJob,
        });

        return createdJob;
    } catch (e: any) {
        dispatch({ type: 'CREATE_JOB_ERROR', error: e?.response?.data });
        throw e;
    }
};

export const doListJobs: Function = (params: GetJobsParams) => async (dispatch: Function) => {
    dispatch({ type: 'LIST_JOBS_REQUEST' });
    try {
        const payload = await listJobs(params);
        dispatch({
            type: 'LIST_JOBS_SUCCESS',
            payload,
        });
        return payload;
    } catch (e: any) {
        dispatch({ type: 'LIST_JOBS_ERROR', error: e?.response?.data });
    }
};

export const doGetJob: Function = (jobId: string) => async (dispatch: Function) => {
    dispatch({ type: 'GET_JOB_REQUEST' });
    try {
        const payload = await getJob(jobId);
        dispatch({
            type: 'GET_JOB_SUCCESS',
            payload,
        });
    } catch (e: any) {
        dispatch({ type: 'GET_JOB_ERROR', error: e?.response?.data });
    }
};

export const doEditJob: Function = (jobId: string, payload: EditJobPayload) => async (dispatch: Function) => {
    dispatch({ type: 'EDIT_JOB_REQUEST' });
    try {
        const updatedJob = await editJob(jobId, payload);
        dispatch({
            type: 'EDIT_JOB_SUCCESS',
            payload: updatedJob,
        });
    } catch (e: any) {
        dispatch({ type: 'EDIT_JOB_ERROR', error: e?.response?.data });
    }
};

export const doListTags: Function = (params?: any) => async (dispatch: Function) => {
    dispatch({ type: 'LIST_JOB_TAGS' });
    try {
        const payload = await listTags(params);
        dispatch({
            type: 'LIST_JOB_TAGS_SUCCESS',
            payload,
        });
    } catch (error: any) {
        dispatch({ type: 'LIST_JOB_TAGS_ERROR', error: error?.response?.data });
    }
};

export const doDeleteJob: Function = (jobId: string) => async (dispatch: Function) => {
    dispatch({ type: 'DELETE_JOB_REQUEST' });
    try {
        const payload = await deleteJob(jobId);
        dispatch({
            type: 'DELETE_JOB_SUCCESS',
            payload,
        });
    } catch (e: any) {
        dispatch({ type: 'DELETE_JOB_ERROR', error: e?.response?.data });
    }
};

export const doArchiveJob: Function = (jobId: string) => async (dispatch: Function) => {
    dispatch({ type: 'ARHIVE_JOB_REQUEST' });
    try {
        const payload = await archiveJob(jobId);
        dispatch({
            type: 'ARHIVE_JOB_SUCCESS',
            payload,
        });
    } catch (e: any) {
        dispatch({ type: 'ARHIVE_JOB_ERROR', error: e?.response?.data });
        throw e;
    }
};

export const doUnarchiveJob: Function = (jobId: string) => async (dispatch: Function) => {
    dispatch({ type: 'UNARHIVE_JOB_REQUEST' });
    try {
        const payload = await unarchiveJob(jobId);
        dispatch({
            type: 'UNARHIVE_JOB_SUCCESS',
            payload,
        });
    } catch (e: any) {
        dispatch({ type: 'UNARHIVE_JOB_ERROR', error: e?.response?.data });
        throw e;
    }
};

export const doUpdateExternalReferences: Function =
    (jobId: string, updatePayload: UpdateExternalReferencesPayload) => async (dispatch: Function) => {
        dispatch({ type: 'UPDATE_EXTERNAL_REFERENCES_REQUEST' });
        try {
            const payload = await updateExternalReferences(jobId, updatePayload);
            dispatch({
                type: 'UPDATE_EXTERNAL_REFERENCES_SUCCESS',
                payload,
            });
        } catch (e: any) {
            dispatch({ type: 'UPDATE_EXTERNAL_REFERENCES_ERROR', error: e?.response?.data });
            throw e;
        }
    };

export const doGetJobInvoicesCount: Function = (jobId: string) => async (dispatch: Function) => {
    dispatch({ type: 'GET_JOB_INVOICES_COUNT_REQUEST' });
    try {
        const response = await listInvoicesByJobId(jobId, { archived: false });
        dispatch({
            type: 'GET_JOB_INVOICES_COUNT_SUCCESS',
            payload: { jobId, count: response.total },
        });
        return response;
    } catch (e: any) {
        dispatch({ type: 'GET_JOB_INVOICES_COUNT_ERROR', error: e?.response?.data });
        throw e;
    }
};
